var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"backup"},[_c('v-btn',{attrs:{"loading":_vm.btnLoading,"color":"primary","title":"Run Backup"},on:{"click":_vm.runBackup}},[_vm._v(" Run Backup ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }